export default __webpack_public_path__ + "static/media/pexels-ready-made-3850790.b304991f.jpg";